import moment from "moment";

// provides min / max date & it's handled in date field itself
export const getValidationDate = (condition, type) => {
  const { minDate, maxDate } = condition;
  let date = null;
  if (type === "min" && minDate) date = minDate;
  if (type === "max" && maxDate) date = maxDate;
  if (date === "today") return new Date();
  if (!date) return null;
  const match = date.match(/([-+])(\d+)(days|weeks|months|years)?/);
  if (!match) return null;
  const operator = match[1];
  let offset = match[2];
  let unit = match[3] || "days";

  if (unit === "days") unit = "d";
  if (unit === "weeks") unit = "w";
  if (unit === "months") unit = "M";
  if (unit === "years") unit = "y";

  if (unit === "d") offset -= 1;

  if (offset && operator === "-")
    return moment().subtract(offset, unit).toDate();
  if (offset && operator === "+") return moment().add(offset, unit).toDate();
  return null;
};

// resolves a relative default date to a Date, ex: "1year", "+6months", "-18years",
// "2weeks", "30days". "today" is handled separately by the date field itself.
// the sign is optional & defaults to a future date; returns null when unsupported
export const getRelativeDefaultDate = (defaultDate) => {
  if (!defaultDate || typeof defaultDate !== "string") return null;
  const match = defaultDate
    .trim()
    .toLowerCase()
    .match(/^([-+])?(\d+)\s*(day|week|month|year)s?$/);
  if (!match) return null;
  const operator = match[1] || "+";
  const offset = +match[2];
  const unitMap = { day: "d", week: "w", month: "M", year: "y" };
  const unit = unitMap[match[3]];
  if (!offset) return new Date();
  if (operator === "-") return moment().subtract(offset, unit).toDate();
  return moment().add(offset, unit).toDate();
};
